import { gsap } from 'gsap';
import { SplitText } from "gsap/SplitText";
import { ScrollTrigger } from "gsap/ScrollTrigger";
//import Swiper from 'swiper/bundle';
// import 'swiper/swiper-bundle.css';
import  GlslCanvas from 'glslCanvas';

gsap.registerPlugin(SplitText, ScrollTrigger);

document.querySelectorAll('.ev-hero__wave-gradient').forEach(layer => {
	console.log(layer);
	waveGradient(layer);
});

async function waveGradient(layer) {


	// const frag = await fetch('wp-content/themes/evoxo-theme/assets/shaders/wave.frag').then(r => r.text());
	const frag = await fetch('wp-content/themes/evoxo-theme/assets/shaders/new_wave.frag').then(r => r.text());

	const canvas = document.createElement('canvas');

	const width = layer.offsetWidth;
	const height = layer.offsetHeight;

	layer.append(canvas);
	canvas.width = width;
	canvas.height = height;

	const sandbox = new GlslCanvas(canvas);
	sandbox.load(frag);

	const gradient = [
		"#001599",
		"#00FF6B",
		"#0022FF",
		"#00FF6B",
	];
	/*
		const gradient = [
			"#001599",
			"#00FF6B",
			"#0022FF",
			"#00FF6B",
		];
	*/
	/*
		const gradient = [
			"hsl(204deg 100% 22%)",
			"hsl(199deg 100% 29%)",
			"hsl(189deg 100% 32%)",
			"hsl(173deg 100% 33%)",
			"hsl(154deg 100% 39%)",
			"hsl( 89deg  70% 56%)",
			"hsl( 55deg 100% 50%)",
		];
	*/
	// Create canvas

	const textureCanvas = document.createElement("canvas");
	const ctx = textureCanvas.getContext("2d");

	textureCanvas.height = height;
	textureCanvas.width = width;

	// Render gradient to texture
	const linearGradient = ctx.createLinearGradient(0, 0, width, 0);
	for (const [i, stop] of gradient.entries()) {
		const t = i / (gradient.length - 1);
		linearGradient.addColorStop(t, stop);
	}
	ctx.fillStyle = linearGradient;
	ctx.fillRect(0, 0, width, height);

	const iData = ctx.getImageData(0, 0, width, height);
	sandbox.uniformTexture('u_gradient', iData);
	sandbox.setUniform('u_w', width);
	sandbox.setUniform('u_h', height);
}

const ffs = n => {
	if (!isFinite(n)) throw new Error('ffs');
	return n;
}


// wait until DOM is ready
document.addEventListener("DOMContentLoaded", function(event){

	// console.log("DOM loaded");

	//wait until images, links, fonts, stylesheets, and js is loaded
	window.addEventListener("load", function(e){
		// console.log("window loaded");

		//custom GSAP code goes here

		document.querySelectorAll('.ev-cards_staggred-slide-in')
			.forEach(
				( container ) => {
					let ctTimelineSlide = gsap.timeline({
						scrollTrigger: container,
					});
					ctTimelineSlide.from(
						container.querySelectorAll('.ev-anim-target'),
						{

							autoAlpha: 0,
							stagger: 0.3,
							y: 150
						}
					).revert();
					// console.log("anim", anim);
				}
			)

		document.querySelectorAll('.ev-staggred-pop-in')
			.forEach(
				( container ) => {
					let ctTimelineSlide = gsap.timeline({
						scrollTrigger: container,
						delay: 0.2
					});
					ctTimelineSlide.from(
						container.querySelectorAll('.ev-anim-target'),
						{

							autoAlpha: 0,
							stagger: 0.3,
							scale: 0.7
							// clearProps: true
						}
					);
					// console.log("anim", anim);
				}
			)


		document.querySelectorAll('.ev-staggered-multi')
			.forEach(
				( container ) => {
					// console.log('ev-staggered-multi', container);
					let evTimeLineMulti = gsap.timeline({
						scrollTrigger: { trigger: container },
						delay: 0.4
					});
					container.querySelectorAll('[class*="ev-anim-"]').forEach(
						( target ) => {
							// console.log('ev-anim-*', target.classList);
							if ( target.classList.contains('ev-anim-pop-in') ) {
								// console.log('ev-anim-pop-in');
								evTimeLineMulti.from(
									target,
									{
										delay: 0.3,
										// autoAlpha: 0,
										opacity: 0,
										scale: 0.7
									},
									"<"
								)
							}
							if ( target.classList.contains('ev-anim-slide-in-end') ) {
								if (window.innerWidth < 600) {
									evTimeLineMulti.from( target, { opacity: 0, y: 150 },"<0.3" )
								} else {
									evTimeLineMulti.from( target, { opacity: 0, x: -150 },"<0.3" )
								}
							}
							if ( target.classList.contains('ev-anim-slide-in-start') ) {
								if (window.innerWidth < 600) {
									evTimeLineMulti.from( target, { opacity: 0, y: 150 },"<0.3" )
								} else {
									evTimeLineMulti.from( target, { opacity: 0, x: 150 },"<0.3" )
								}
							}
							if ( target.classList.contains('ev-anim-slide-in-bottom') ) {
								evTimeLineMulti.from( target, { opacity: 0, y: 150 }, "<0.3" )
							}
							if ( target.classList.contains('ev-anim-fade-in') ) {
								evTimeLineMulti.from(
									target,
									{
										// delay: 0.3,
										opacity: 0
										// scale: 0.7
									},
									"<0.3"
								)
							}
						});

				}
			)

		let splitWordSlideIn = gsap.from(
			SplitText.create('.ev-split-word-slide-in',{type: "words"}).words,
			{
				autoAlpha: 0,
				y: -70,
				stagger: 0.2,
				delay: 0.4
			}
		);

		const evNumbers = document.querySelectorAll('.ev-main__numbers .ev-main__number>mark');

		gsap.from(evNumbers, {
			scrollTrigger: '.ev-main__numbers',
			innerText: 0,
			duration: 2,
			stagger: 0.4,
			snap : {
				innerText: 1
			}
		});

		let typeWriter = gsap.from(
			SplitText.create('.ev-anim-typewriter', {type: "chars"}).chars, {
				autoAlpha: 0,
				stagger: 0.2,
				delay: 0.4,
				ease: "steps(1)",
				scrollTrigger: '.ev-anim-typewriter'
			}
		)

		let ctTimelineFade = gsap.timeline();
		ctTimelineFade.from(
			'.ev-fade-in',
			{
				scrollTrigger: '.ev-fade-in',
				autoAlpha: 0,
				duration: 0.6
			}
		)



		// let heroWordmarkSlideInTL = gsap.timeline({duration: 1, ease: "power2.inOut", autoAlpha: 0});
		// heroWordmarkSlideInTL.addLabel('start');

		// heroWordmarkSlideInTL.from('.ev-hero-layer__wordmark > .letter_c',{ x: -200, y: -200},'start');
		// heroWordmarkSlideInTL.from('.ev-hero-layer__wordmark > .letter_o',{ x: 200, y: -200},'start+=0.4');
		// heroWordmarkSlideInTL.from('.ev-hero-layer__wordmark > .letter_d',{ x: -200, y: 200},'start+=0.8');
		// heroWordmarkSlideInTL.from('.ev-hero-layer__wordmark > .letter_e',{ x: 200, y: 200},'start+=1.2');

		gsap.from(
			'.ev-hero-layer__wordmark > div',
			{
				autoAlpha: 0,
				scale: 0.7,
				ease: "power2.out",
				stagger: 0.3,
				duration: 0.8
			}
		);
		gsap.from(
			'.ev-hero-layer__dots',
			{
				autoAlpha: 0,
				ease: "power2.in",
				duration: 0.8
			}
		);

		document.querySelectorAll('.ev-swiper__dots').forEach(ctr => {

			let interval = 1500;
			let backoffBy = 2000;

			let backoff = 0;
			let x0 = null;
			let scroll0 = null;
			let timer = 0;

			const children = [...ctr.children];
			let dotCtr, dots;

			const dotsWrapper = ctr.closest('.ev-swiper__dots-wrapper');

			let curDot = 0;

			const setBackoff = () => {
				backoff = Date.now() + backoffBy;
			};

			const move = e => {
				e.preventDefault();
				setBackoff();
				const d = ffs(x0 - e.clientX);
				ctr.scrollTo({
					top: 0,
					left: scroll0 + d,
					behavior: 'instant'
				});
			};
			const up = e => {
				document.body.removeEventListener('mousemove', move);
				document.body.removeEventListener('mouseup', up);
				ctr.style.userSelect = '';
				ctr.style.scrollSnapType = '';
				x0 = null;
			};
			ctr.addEventListener('mousedown', e => {
				e.preventDefault();
				x0 = ffs(e.clientX);
				scroll0 = ffs(ctr.scrollLeft);
				ctr.style.userSelect = 'none';
				ctr.style.scrollSnapType = 'none';
				document.body.addEventListener('mousemove', move);
				document.body.addEventListener('mouseup', up);
			});

			const goToDot = num => {
				dots[curDot].classList.remove('ev-swiper__dots-dot_active');
				curDot = num;
				dots[curDot].classList.add('ev-swiper__dots-dot_active');
				ctr.scrollTo({
					top: 0,
					left: children[curDot].offsetLeft,
					behavior: 'smooth',
				});
			}

			const step = by => {
				goToDot((curDot + by) % dots.length);
			};


			dotCtr = document.createElement('div');
			dotCtr.classList.add('ev-swiper__dots-nav');
			dotsWrapper.append(dotCtr);
			dots = [];
			for (let i = 0; i < children.length; i++) {
				const dot = document.createElement('button');
				dot.classList.add('ev-swiper__dots-dot');
				dot.addEventListener('click', () => goToDot(i));
				dotCtr.append(dot);
				dots.push(dot);
			}
			dots[0].classList.add('ev-swiper__dots-dot_active');

			const stop = () => {
				// console.log('stop');
				clearInterval(timer);
				timer = null;
			}
			const play = () => {
				// console.log('play');
				stop();
				timer = setInterval(() => {
					if (Date.now() < backoff) {
						console.log('wait');
						return;
					}
					step(1);
				}, interval);
			}
			ctr.addEventListener('mouseenter', setBackoff);
			ctr.addEventListener('touchmove', setBackoff);
			const observer = new IntersectionObserver(([e]) => {
				if (!e.isIntersecting && timer) stop();
				else if (e.isIntersecting && !timer) play();
			}, { threshold: 0.2 });
			observer.observe(ctr);


		});


		document.querySelectorAll('.ev-swiper__cards').forEach(ctr => {

			const interval = 2000;
			const duration = 1000;
			let backoffBy = 500;

			let backoff = 0;
			let x0 = null;
			let scroll0 = null;
			let timer = 0;

			const initial = [...ctr.children];
			const count = initial.length;
			const clones = initial.map(() => []);

			const outer = ctr.closest('.ev-swiper__cards-outer');
			const wrapper = ctr.closest('.ev-main-cases-wrapper');

			const setBackoff = () => {
				backoff = Date.now() + backoffBy;
			};

			let animate = false, scheduled = 0;
			let scroll = 0, prev = 0, origin = 0, target = 0;
			let paddingLeft, childWidth, outerWidth;
			const usedClones = new Map();

			const provideClone = pos => {
				const id = pos % count;
				let clone = clones[id].pop();
				// console.log('provideClone', pos, clone);
				if (!clone) {
					clone = initial[id].cloneNode(true);
					ctr.append(clone);
				}
				const visual = pos % 3;
				clone.setAttribute('style', initial[visual].getAttribute('style')); // ew
				clone.className = initial[visual].className;
				clone.style.position = 'absolute';
				clone.style.top = 0;
				clone.style.left = (childWidth * pos) + 'px';
				clone.style.visibility = 'visible';
				usedClones.set(pos, clone);
			};
			const releaseClone = pos => {
				const id = pos % count;
				const clone = usedClones.get(pos);
				// console.log('releaseClone', pos, clone);
				clone.style.visibility = 'hidden';
				clones[id].push(clone);
				usedClones.delete(pos, clone);
			}

			function easeInOutCubic(x) {
				return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
			}

			let t0 = null;
			const loop = () => {

				scheduled--;

				const t = Date.now();

				if (!animate) return;
				// console.log(target);
				scheduled++;
				window.requestAnimationFrame(loop);

				if (!isFinite(scroll) || !isFinite(target)) {
					console.log(scroll, target);
					origin = scroll = target = 0; // ffs
				}

				if (!t0 || target == scroll || Math.abs(target - scroll) < 1) {
					origin = scroll = target;
					animate = false;
				}
				else {
					const x = Math.max(0, Math.min(1, (t - t0) / duration));
					const y = easeInOutCubic(x);
					scroll = Math.round(origin + (target - origin) * y);
				}

				// console.log(scroll, target);

				ctr.style.transform = `translate(${-scroll}px, 0)`;
				prev = scroll;

				const firstVis = Math.max(count, Math.round((scroll - paddingLeft - childWidth * 3) / childWidth));
				const lastVis = Math.round((scroll + outerWidth + childWidth * 3) / childWidth);

				for (const key of usedClones.keys()) {
					if (key < firstVis || key > lastVis) releaseClone(key);
				}
				for (let i = firstVis; i <= lastVis; i++) {
					if (!usedClones.has(i)) provideClone(i);
				}

			};
			const schedule = () => {
				// console.log(animate, scheduled, lastT);
				if (animate) return;
				animate = true;
				if (scheduled) return;
				scheduled++;
				window.requestAnimationFrame(loop);
			};

			const setTarget = px => {
				t0 = Date.now();
				origin = scroll;
				target = px;
				schedule();
			}

			let touchId = -1;
			const move = e => {
				setBackoff();
				let x;
				if (e.targetTouches) {
					const t = [... e.targetTouches].find(t => t.identifier == touchId);
					if (!t) return;
					x = t.clientX;
				}
				else {
					x = e.clientX;
					e.preventDefault();
				}
				// console.log(x);
				const d = ffs(x0 - x);
				scroll = ffs(scroll0 + d);
				if (scroll < 0) scroll = ffs(-Math.pow(-scroll, 0.7));
				origin = target = scroll;
				t0 = null;
				schedule();
			};
			const up = e => {
				// if (e.targetTouches && ![...e.targetTouches].find(t => t.identifier == touchId)) return;
				e.preventDefault();
				document.body.removeEventListener('mousemove', move);
				document.body.removeEventListener('mouseup', up);
				document.body.removeEventListener('touchmove', move);
				document.body.removeEventListener('touchend', up);
				ctr.style.userSelect = '';
				// ctr.style.scrollSnapType = '';
				x0 = null;
				// console.log(scroll, scroll + getInertia() * 100, getInertia());
				origin = scroll;
				setTarget(ffs(Math.max(0, Math.round(scroll / childWidth) * childWidth)));
				touchId = -1;
			};
			outer.addEventListener('mousedown', e => {
				// e.preventDefault();
				x0 = e.clientX;
				scroll0 = ffs(scroll);
				ctr.style.userSelect = 'none';
				// ctr.style.scrollSnapType = 'none';
				document.body.addEventListener('mousemove', move);
				document.body.addEventListener('mouseup', up);
			});
			outer.addEventListener('touchstart', e => {
				if (touchId >= 0) return;
				e.preventDefault();
				const t = e.targetTouches[0];
				touchId = t.identifier;
				// console.log(t);
				x0 = t.clientX;
				// console.log('x0', x0);
				scroll0 = scroll;
				ctr.style.userSelect = 'none';
				// ctr.style.scrollSnapType = 'none';
				document.body.addEventListener('touchmove', move);
				document.body.addEventListener('touchend', up);
			});

			const step = by => {
				const curIdx = Math.round(target / childWidth);
				const idx = Math.max(0, curIdx + by);
				setTarget(idx * childWidth);
			};

			if (wrapper) {
				wrapper.querySelector('.ev-main__swiper-prev')?.addEventListener('click', () => {
					setBackoff();
					step(-1);
				});
				wrapper.querySelector('.ev-main__swiper-next')?.addEventListener('click', () => {
					setBackoff();
					step(1);
				});
			}

			const stop = () => {
				// console.trace('stop', animate);
				clearInterval(timer);
				timer = null;
			}
			const play = () => {
				// console.log('play', animate);
				stop();
				timer = setInterval(() => {
					if (Date.now() < backoff || x0 || scroll != target) {
						// console.log('wait');
						return;
					}
					step(1);
				}, interval);
			}
			ctr.addEventListener('mouseenter', setBackoff);
			ctr.addEventListener('touchmove', setBackoff);
			const observer = new IntersectionObserver(([e]) => {
				if (e.isIntersecting && !timer) play();
				observer.unobserve(ctr);
			}, { threshold: 0.2 });
			observer.observe(ctr);

			const reflow = () => {
				const comp = window.getComputedStyle(outer);
				paddingLeft = Math.round(parseFloat(comp.paddingLeft));
				outerWidth = outer.offsetWidth;
				childWidth = ffs(initial[1].offsetLeft - initial[0].offsetLeft);
				schedule();
			}
			reflow();
			window.addEventListener('resize', reflow);


		});


/*
		let evMainBornSwiper = new Swiper('.ev-main-cases-swiper', {
			direction: "horizontal",
			// loop: true,
			autoplay: {
				delay: 1700,
				pauseOnMouseEnter: true,
				// reverseDirection: true,
			},
			touch: true,
			navigation: {
				nextEl: '.ev-main__swiper-next',
				pervEl: '.ev-main__swiper-prev',
			},
			// width: 250,
			// enabled: false,
			slidesPerView: 'auto',
			rewind: true,
			slidesOffsetAfter: 53,
			// createElements: true,
			// centerInsufficientSlides: true,
			// centeredSlidesBounds: true,
			// centeredSlides: false,
			// spaceBetween: 8,
			// pagination: {el: ".swiper-pagination"},
			// virtual: true,
			// autoHeight: false
			// height:
		});
		console.log('swiper', evMainBornSwiper);
*/

/*
		let evFooterSwiper = new Swiper('.ev-footer__swiper-target', {
			direction: "horizontal",
			autoplay: {delay: 700, pauseOnMouseEnter: true},
			loop: true
		});
		console.log('swiper-footer', evMainBornSwiper);
*/

		// Main page Advantages — fold/unfold cards on click and by timer

/*
		const mainAdvantage = document.querySelector('.ev-main-advantage');
		// console.log(window.innerWidth);
		if (mainAdvantage && (window.innerWidth > 600)) {

			const contentSel = 'p:last-child'; // todo less dum?
			const interval = 2_000;
			const afterClick = 5_000;

			const right = mainAdvantage.querySelector('.ev-advantages-right');
			const folds = [...mainAdvantage.querySelectorAll(".ev-adv__fold")];
			let active = folds.findIndex(fold => fold.classList.contains('ev-fold__active'));
			let timer;

			const activate = idx => {

				if (timer) clearTimeout(timer);
				right.style.minHeight = right.offsetHeight + 'px';

				const prev = folds[active];
				const next = folds[idx];
				active = idx;

				prev.classList.remove('ev-fold__active');
				next.classList.add('ev-fold__active');
				prev.querySelector(contentSel).style.height = '0';
				const nextP = next.querySelector(contentSel);
				nextP.style.height = nextP.scrollHeight + 'px';

				timer = setTimeout(rotate, interval);

			};

			const rotate = () => {
				activate((active + 1) % folds.length);
			}

			const resize = () => {
				right.style.minHeight = '';
				for (const [idx, fold] of folds.entries()) {
					const p = fold.querySelector(contentSel);
					p.style.height = idx == active ? p.scrollHeight + 'px' : '0';
				}
				setTimeout(() => {
					right.style.minHeight = right.offsetHeight + 'px';
				}, 1)
			}

			timer = setTimeout(rotate, interval);

			document.addEventListener('resize', resize);
			resize();

			for (const [idx, fold] of folds.entries()) {
				fold.addEventListener('click', () => {
					if (active != idx) activate(idx);
					clearTimeout(timer);
					timer = setTimeout(rotate, afterClick);
				});
			}

		}

		const techScalable = document.querySelector('.ev-main-life');
		if (techScalable && (window.innerWidth > 600)) {

			const interval = 2_000;
			const folds = [...techScalable.querySelectorAll('.ev-main-life-flip')];

			let active = -1;
			let over = null;
			let timer;

			const activate = idx => {

				if (timer) clearTimeout(timer);

				const prev = folds[active];
				const next = folds[idx];
				active = idx;

				if (prev) {
					prev.classList.remove('ev-main-life-flip__active');
				}

				next.classList.add('ev-main-life-flip__active');

				timer = setTimeout(rotate, interval);

			};

			const rotate = () => {
				activate((active + 1) % folds.length);
			}

			for (const [idx, fold] of folds.entries()) {
				fold.addEventListener('mouseenter', () => {
					over = idx;
					if (active != idx) activate(idx);
					clearTimeout(timer);
				});
				fold.addEventListener('mouseleave', () => {
					if (over == idx) {
						over = null;
						timer = setTimeout(rotate, interval);
					}
				});
			}

			activate(0);

		}
*/

		document.querySelectorAll('.ev-anim__punch-in_container').forEach(ctr => {
			const targets = ctr.querySelectorAll('.ev-anim__punch-in_target');
			console.log(targets.length);
			if (targets.length < 2) return;
			let active = 0;
			let id = 0;
			const setActive = i => {
				targets[active].classList.remove('ev-anim__punch-in_active');
				active = i;
				targets[active].classList.add('ev-anim__punch-in_active');
			};
			const stop = () => clearInterval(id);
			const play = () => {
				stop();
				id = setInterval(() => {
					setActive((active + 1) % targets.length);
				}, 1000);
			}
			targets.forEach((tgt, i) => {
				tgt.addEventListener('pointerenter', () => {
					stop();
					setActive(i);
				});
			});
			ctr.addEventListener('pointerleave', () => play());
			const observer = new IntersectionObserver(e => {
				if (!e[0].isIntersecting) return;
				play();
				observer.disconnect();
			}, { threshold: 0.1 });
			observer.observe(ctr);
		});


/*
		document.querySelectorAll('.ev-hero__wave-gradient').forEach(layer => {
			console.log(layer);
			waveGradient(layer);
		});
*/

	}, false);

});



